import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { selectAuth } from '../features/authSlice'
import { RootState } from '../store'
import { API_END_POINTS } from './apiEndpoints'
import { baseUrl } from './baseUrl'
import { DynamicBaseQueryHeader } from './DynamicBaseQueryHeader'

// const rawBaseQuery = fetchBaseQuery({
//     baseUrl: baseUrl.MAIN_BASE_URL,
// })

// type ExtraOptions = {
//     headers?: Record<string, string>;
//     // Define other optional properties here if needed
// };

// const dynamicBaseQuery: BaseQueryFn<
//     string | FetchArgs,
//     unknown,
//     FetchBaseQueryError,
//     ExtraOptions
// > = async (args, api, extraOptions) => {
//     const orgBaseUrl = selectAuth(api.getState() as RootState).baseURL;
//     // gracefully handle scenarios where data to generate the URL is missing
//     if (!orgBaseUrl) {
//         return {
//             error: {
//                 status: 400,
//                 statusText: 'Bad Request',
//                 data: 'dynamic route not found',
//             },
//         }
//     }

//     const urlEnd = typeof args === 'string' ? args : args.url

//     // construct a dynamically generated portion of the url
//     const adjustedUrl = `${orgBaseUrl}/api/AutomationBankFilesFeed${urlEnd}`
//     const adjustedArgs = typeof args === 'string' ? { url: adjustedUrl } : { ...args, url: adjustedUrl };
//     // Get the token from localStorage
//     const token = localStorage.getItem("user")
//         ? JSON.parse(localStorage.getItem("user")!).token
//         : null;
//     // Set headers if token is available
//     const headers = token ? { Authorization: `Bearer ${token}` } : {};
//     // Merge headers with existing headers
//     const mergedHeaders = { ...headers, ...extraOptions?.headers };
//     // provide the amended url and other params to the raw base query
//     return rawBaseQuery({ ...adjustedArgs, headers: mergedHeaders }, api, extraOptions)

// }

export const AutomationApi = createApi({
  reducerPath: 'AutomationApi',
  // baseQuery: dynamicBaseQuery,
  baseQuery: DynamicBaseQueryHeader('AutomationBankFilesFeed'),
  endpoints: (builder) => ({
    getAllBankFilesLineItems: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getAllBankFilesLineItems}`,
          method: 'GET',
          params,
        }
      },
    }),
    getAutomationBankFilesFeedParsingStats: builder.query({
      query: ({ pageNumber, pageSize, sortBy, sortOrder, filterByStatus, searchStr }) => {
        return {
          url: `${API_END_POINTS.getAutomationBankFilesFeedParsingStats}?pageSize=${pageSize}&pageNumber=${pageNumber}&sortBy=${sortBy}&sortOrder=${sortOrder}&searchStr=${searchStr}&filterByStatus=${filterByStatus}`,
          method: 'GET',
        }
      },
    }),
    getBankFilesLineitemsV2: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getBankFilesLineitemsV2}`,
          method: 'GET',
          params,
        }
      },
    }),
    getBankFilesLineitemsReconcilation: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getBankFilesLineitemsReconcilation}`,
          method: 'GET',
          params,
        }
      },
    }),
    getBankFilesLineitemsV2Excel: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getBankFilesLineitemsV2Excel}`,
          method: 'GET',
          params,
          responseHandler: async (response) => {
            const blob = await response.blob() // Convert response to blob
            return blob
          },
        }
      },
    }),
    getAllBankAndUserLineItems: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getAllBankAndUserLineItems}`,
          method: 'GET',
          params,
        }
      },
    }),
    getAllBankLineItems: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getAllBankLineItems}`,
          method: 'GET',
          params,
        }
      },
    }),
    getAllBankLineItemsOfCurrentUser: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getAllBankLineItemsOfCurrentUser}`,
          method: 'GET',
          params,
        }
      },
    }),
    getAllLineItemsDraftByUser: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getAllLineItemsDraftByUser}`,
          method: 'GET',
          params,
        }
      },
    }),
    getCCFeedMissingFiles: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getCCFeedMissingFiles}`,
          method: 'GET',
          params,
        }
      },
    }),
  }),
})

export const {
  useGetAllBankFilesLineItemsQuery,
  useGetAutomationBankFilesFeedParsingStatsQuery,
  useGetBankFilesLineitemsV2Query,
  useGetBankFilesLineitemsReconcilationQuery,
  useGetAllBankAndUserLineItemsQuery,
  useGetAllBankLineItemsQuery,
  useGetAllLineItemsDraftByUserQuery,
  useGetBankFilesLineitemsV2ExcelQuery,
  useLazyGetBankFilesLineitemsV2ExcelQuery,
  useGetAllBankLineItemsOfCurrentUserQuery,
  useGetCCFeedMissingFilesQuery,
} = AutomationApi
